import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { data } from '../../../data';


function Items({ currentItems }) {
    return (
        <>
            {currentItems &&
                currentItems.map((item) => (
                    <div class="card mb-3" >
                        <div class="row g-3">
                            <div class="col-md-4 p-3 " >
                                <img style={{ "marginLeft": "22px" }}
                                    src={item.img}
                                    alt=""
                                    class="img-fluid rounded-start"
                                    width={250}
                                />
                            </div>
                            <div class="col-md-7">
                                <div class="card-body">
                                    <h6 class="card-title">{item.title}</h6>
                                    <div className="" style={{ "fontSize": "12px" }}>
                                        18-уми июни соли ҷорӣ дар муассисаи таҳсилоти миёнаи умумии №14-и ноҳияи Нуробод
                                        барои истиқоматкунандагони шаҳру ноҳияҳои Роғун, Файзобод, Нуробод, Сангвор,
                                    </div>
                                    <p class="card-text">
                                        <small> <span class="card_date text-warning" >{item.date}</span></small>
                                    </p>
                                    <div className="d-flex justify-content-end">
                                        <button type="button" class="btn btn-warning  ">Давомаш</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
        </>
    );
}

function Pagination({ itemsPerPage }) {
    const [currentItems, setCurrentItems] = useState(data);
    const [pageCount, setPageCount] = useState(0);

    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    return (
        <>
            <Items currentItems={currentItems} />
            <div className='pagin d-flex justify-content-center pt-4'>
                <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="<"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                />
            </div>

        </>
    );
}

export default Pagination;